// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__1zFBr","alert":"SettungsInbox_alert__3cZJV"};